export default __webpack_public_path__ + "static/media/avatar_group.cd06d714.svg";